/**
 * @generated SignedSource<<fb1a8121fe8317fe0b06b8610c3426e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type PopupImportJobStatus = "QUEUED" | "RUNNING" | "COMPLETED" | "COMPLETED_WITH_ERRORS" | "FAILED" | "%future added value";
export type PopupImportPageContainerActiveJobQuery$variables = {};
export type PopupImportPageContainerActiveJobQueryVariables = PopupImportPageContainerActiveJobQuery$variables;
export type PopupImportPageContainerActiveJobQuery$data = {
  readonly activePopupImportJob: {
    readonly slug: string;
    readonly status: PopupImportJobStatus;
  } | null;
};
export type PopupImportPageContainerActiveJobQueryResponse = PopupImportPageContainerActiveJobQuery$data;
export type PopupImportPageContainerActiveJobQuery = {
  variables: PopupImportPageContainerActiveJobQueryVariables;
  response: PopupImportPageContainerActiveJobQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PopupImportPageContainerActiveJobQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PopupImportJob",
        "kind": "LinkedField",
        "name": "activePopupImportJob",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PopupImportPageContainerActiveJobQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PopupImportJob",
        "kind": "LinkedField",
        "name": "activePopupImportJob",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2d38c941ec1ab16b3a975dad343de11f",
    "id": null,
    "metadata": {},
    "name": "PopupImportPageContainerActiveJobQuery",
    "operationKind": "query",
    "text": "query PopupImportPageContainerActiveJobQuery {\n  activePopupImportJob {\n    slug\n    status\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "fb985914bf66413e6fd18425c307792f";

export default node;
